import React, { useEffect, useState } from "react";
import { getBlogById } from "../../services/blogService";
import { useParams } from "react-router-dom";
import parse from "html-react-parser";

const ViewBlog = () => {
  const { blog_id } = useParams();
  const [blog, setBlog] = useState({});
  const [blogLoading, setBlogLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useState(() => {
    const fetchBlogById = async () => {
      const res = await getBlogById(blog_id);
      setBlog(res?.data);
      setBlogLoading(false);
    };
    fetchBlogById();
  }, []);
  return (
    <div className="px-8 sm:px-48 pt-4 sm:py-12 min-h-screen">
      {blogLoading ? (
        <div>Loading...</div>
      ) : (
        <div className="flex flex-col">
          <div className="text-3xl font-semibold">{blog?.name}</div>
          <div className="text-lg uppercase font-light text-sm pl-[2px] pt-2">
            {new Date(blog?.created_at).toDateString()}
          </div>
          <div className="no-tailwindcss-base pt-4 pl-[4px]">
            {parse(blog.blog_text)}
          </div>
        </div>
      )}
    </div>
  );
};

export default ViewBlog;
